import { styled } from '@mui/material/styles';
import Tail from 'assets/images/tail.svg';
import { bool, node } from 'prop-types';
import React from 'react';
import { MESSAGE_BUBBLE_MAX_WIDTH_PX } from '../messageBubbleMaxWidth';

const Wrapper = styled('div')({
  position: 'relative',
});

const Root = styled('div', {
  shouldForwardProp: prop => prop !== 'right' && prop !== 'isMandatory',
})(({ theme, right, isMandatory }) => {
  const rightBg =
    theme.palette.mode === 'light'
      ? theme.palette.primary.lighter
      : theme.palette.primary.ultraLight;
  const backgroundColor = right && !isMandatory ? rightBg : theme.palette.background.paper;
  if (isMandatory) {
    return {
      borderRadius: '20px',
    };
  }
  return {
    borderRadius: '20px',
    maxWidth: MESSAGE_BUBBLE_MAX_WIDTH_PX,
    boxShadow: '2px 2px 3px -1px rgba(2, 2, 3, 0.2)',
    position: 'relative',
    border: '2px solid white',
    backgroundColor,
    borderColor: backgroundColor,
  };
});

const OverflowContainer = styled('div', {
  shouldForwardProp: prop => prop !== 'isMandatory',
})(({ isMandatory }) => ({
  position: 'relative',
  borderRadius: '17px',
  width: '100%',
  height: '100%',
  ...(!isMandatory && {
    overflow: 'hidden',
    wordBreak: 'break-word',
  }),
}));

const TailIcon = styled(Tail, {
  shouldForwardProp: prop => prop !== 'right',
})(({ theme, right }) => {
  const rightBg =
    theme.palette.mode === 'light'
      ? theme.palette.primary.lighter
      : theme.palette.primary.ultraLight;
  return {
    zIndex: 11,
    width: '19px',
    color: right ? rightBg : theme.palette.background.paper,
    position: 'absolute',
    bottom: '-2px',
    left: '-9px',
    ...(right
      ? {
          left: 'auto',
          right: '-9px',
          transform: 'scaleX(-1)',
        }
      : {}),
  };
});

const BaseMessage = ({ right, isMandatory, children }) => (
  <Wrapper>
    <Root right={right} isMandatory={isMandatory}>
      <OverflowContainer isMandatory={isMandatory}>{children}</OverflowContainer>
    </Root>
    {!isMandatory && <TailIcon right={right} />}
  </Wrapper>
);
BaseMessage.propTypes = {
  attachments: bool.isRequired,
  children: node.isRequired,
  right: bool.isRequired,
  isMandatory: bool.isRequired,
};

export default BaseMessage;
